import React from 'react';
import Images from '../../components/images';
import { ProfileVerifyStep } from './CustomComponents';
import { Utilities, blobToFile, isFooterTab, compressImg } from '../../Utilities/Utilities'
import WSManager from '../../WSHelper/WSManager';
import * as WSC from "../../WSHelper/WSConstants";
import ls from 'local-storage';
import * as AppLabels from "../../helper/AppLabels";
import { OnlyCoinsFlow } from '../../helper/Constants';

const options = {
    maxWidthOrHeight: 300
}
let globalThis = null;
export default class UserProfileHeader extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            UserProfileDetail: (this.props.UserProfileDetail || ls.get('profile')) || '',
            profileImageFile: '',
            selectedProfileImage: '',
            imageUrl: '',
            cameraPermisiionGranted: false,

        }
        this.onDrop = this.onDrop.bind(this);
    }

    isAccountVerified = (data) => {
        return (data.pan_verified == "1" && data.is_bank_verified == "1" && data.email_verified == "1" && data.phone_verfied == "1") ? true : false
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            UserProfileDetail: nextProps.UserProfileDetail,
            imageUrl: this.props.UserProfileDetail.image
        })

    }

    componentDidMount = () => {
        this.handelCameraPermission()
    };
    actionPancard = () => {
        if (WSManager.getIsIOSApp()) {
            this.upload.click()
        }
        else if (window.ReactNativeWebView && !this.state.cameraPermisiionGranted) {

            let data = {
                action: 'profilepic',
                targetFunc: 'profilepic',
            }
            window.ReactNativeWebView.postMessage(JSON.stringify(data));
        }
        else {
            this.upload.click()
        }
    }

    handelCameraPermission() {
        window.addEventListener('message', (e) => {

            if (e.data.action == 'profilepic' && e.data.type == 'granted') {
                this.setState({ cameraPermisiionGranted: true }, () => {
                    if (this.state.cameraPermisiionGranted) {
                        this.upload.click()
                    }
                })
            }
            else if (e.data.action == 'profilepic' && e.data.type == 'denied') {
                this.setState({ cameraPermisiionGranted: false })

            }

        });
    }

    onDrop(e) {
        e.preventDefault();
        let reader = new FileReader();
        let mfile = e.target.files[0];
        reader.onloadend = () => {
            this.setState({ selectedProfileImage: reader.result })
            this.compressImage(mfile)
        }
        reader.readAsDataURL(mfile)
    }
    compressImage = async (mfile) => {
        compressImg(mfile, options).then((compressedFile) => {
            this.setState({ profileImageFile: blobToFile(compressedFile ? compressedFile : mfile, mfile.name) }, () => {
                this.uploadImage()
            })
        })
    }

    uploadImage() {
        this.setState({ isLoading: true });
        var data = new FormData();
        data.append("userfile", this.state.profileImageFile);
        data.append("update_image_record", '1');
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.addEventListener("readystatechange", function () {
            if (this.readyState == 4) {
                if (!this.responseText) {
                    Utilities.showToast(AppLabels.SOMETHING_ERROR, 5000, Images.PAN_ICON);
                    return;
                }
                var response = JSON.parse(this.responseText);
                if (response !== '' && response.response_code == WSC.successCode) {
                    globalThis.setState({ imageUrl: response.data.file_name })
                }
                else {
                    if (response.global_error && response.global_error != '') {
                        Utilities.showToast(response.global_error, 5000);
                    }
                    else {
                        var keys = Object.keys(response.error);
                        if (keys.length > 0) {
                            Utilities.showToast(response.global_error, 5000);
                        }
                    }
                }

            }
        });

        xhr.open("POST", WSC.userURL + WSC.DO_UPLOAD);
        xhr.setRequestHeader('Sessionkey', WSManager.getToken())
        xhr.send(data);
    }

    render() {
        globalThis = this;

        let { IsImgEditable, EditUserNameModalShow, IsProfileVerifyShow, goToVerifyAccount, StepList, accVerified } = this.props;
        let { imageUrl, selectedProfileImage, UserProfileDetail } = this.state;
        return (
            <div className={"user-profile-section" + (!isFooterTab('my-profile') ? ' pt-0' : '')}>
                <div className="overlay-white-circle"></div>
                <div className="profile-cont">
                <div className="text-center profile-img-section">
                    <figure>
                        <input id="myInput"
                            type="file"
                            accept="image/*"
                            ref={(ref) => this.upload = ref}
                            style={{ display: 'none' }}
                            onChange={this.onDrop.bind(this)}
                        />
                        <img src={imageUrl !== '' ? Utilities.getThumbURL(imageUrl) :
                            (selectedProfileImage !== '' ? selectedProfileImage : Images.DEFAULT_AVATAR)} alt="" />
                    </figure>
                    {IsImgEditable &&
                        <span id="uploadImage" onClick={() => window.ReactNativeWebView ? this.actionPancard() : this.upload.click()} className="change-img">
                            <span className="icon-wrapper"><i className="icon-camera-fill"></i></span>
                        </span>
                    }
                </div>
                <div className="user-name">
                    {UserProfileDetail.first_name &&
                        (UserProfileDetail.first_name + ' ' + (UserProfileDetail.last_name || ''))
                    }
                </div>
                <div className="user-profile-name">
                    {UserProfileDetail.user_name}
                    <a href id="changeUserName" onClick={EditUserNameModalShow} className="editUserName" >
                        <i className="icon-edit"></i>
                    </a>
                </div>
                </div>
                {IsProfileVerifyShow &&
                    <div>
                        <ProfileVerifyStep OnlyCoinsFlow={OnlyCoinsFlow} goToVerifyAccount={goToVerifyAccount} StepList={StepList} accVerified={accVerified} />
                    </div>
                }
            </div>
        )
    }
}